import axiosInterceptor from './AxiosInterceptor';
import { makeSecureAPICall } from "./SignatureHelperFn";

// export const BaseUrl = ENVIRONMENTS[SELECTED_ENVIRONMENT].baseurl || "";
export const baseUrl = process.env.REACT_APP_BASE_API_URL;
export const idmUrl = process.env.REACT_APP_IDM_URL;

axiosInterceptor();

// Refactored API function using the generic approach

// Geography Chart API
export const getGeographyChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/geography-chart`, payload);
};

// Therapy Area Chart API (Bar Chart)
export const getTherapyAreaChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/therapy-area-chart`, payload);
};

// TA Sub Indication API
export const getTaSubIndication = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/ta-ind-subind-chart`, payload);
};

export const getPrimaryTaIndication = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/primary-ta-ind-chart`, payload);
};

// Indication Chart API (Bar Chart)
export const getIndicationChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/indication-chart`, payload);
};

// Sub-Indication Chart API (Bar Chart)
export const getSubIndicationChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/sub-indication-chart`, payload);
};

// Age Chart API (Bar Chart)
export const getAgeChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/age-chart`, payload);
};

// Gender Chart API (Bar Chart)
export const getGenderChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/gender-chart`, payload);
};

// Demographics Chart API (Bar Chart)
export const getDemographicsChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/demographics-chart`, payload);
};

// Patient Funnel Chart API (Bar Chart)
export const getPatientFunnelChart = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/explore-patient-funnel`, payload);
};

// Categories with Questions that Have 25+ Respondents API
export const getQuestionsRespondentData = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/greater-respondents-data`, payload);
};

// Filter dropdown values/list API
export const getExploreFilterDropdownDataAPI = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/explore-filter-dropdown`, payload);
};

// Save explore filter API
export const saveExploreFilterAPI = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/explore-save-filters-data`, payload);
};

// Display explore filter data API
export const displayExploreFilterDataAPI = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/explore-display-filters-data`, payload);
};

// Download explore responses API
export const downloadExploreResponses = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/download-explore-responses`, payload);
};



